<div class="card documentation">
  <div class="warning-message">
    <app-reminder-message
      *ngIf="auth.complianceChecks?.expiredFunds"
      message="Tu origen de fondos expiró, para aumentar tu límite tendrás que subir un origen de fondos nuevamente"
      [type]="'warning'"
    >
    </app-reminder-message>
  </div>
  <h2 class="documentation-title">Límites de operación</h2>
  <p class="documentation-subtitle">
    Sin subir documentación los límites de operación en la plataforma son de
    <span class="bold">AR$ {{ depositLimits['monthly'].limit | number : '0.2-2' }}</span> mensual y
    <span class="bold">AR$ {{ depositLimits['yearly'].limit | number : '0.2-2' }}</span> anual.
  </p>
  <div class="user-limits">
    <div class="user-operations">
      <!-- Si no tiene monthly su limite es anual -->

      <div class="operation">
        <div class="operation-header">
          <img src="/assets/icons/deposit.svg" alt="Limite de operacion" />
          <p class="title">Límites de depósito</p>
          <app-selector
            [values]="optionsTime"
            (changeSelected)="depositTime = $event"
          ></app-selector>
        </div>

        <p class="amount">
          {{ +depositLimits[depositTime].limit | number : '0.2-2' }} <span>AR$</span>
        </p>

        <div class="progress">
          <div class="progress-values">
            <h3 class="used">Utilizados:</h3>
            <h3 class="limit">Límite:</h3>
          </div>
          <mat-progress-bar
            color="fff"
            mode="determinate"
            [value]="
              (+depositLimits[depositTime].deposited / +depositLimits[depositTime].limit) * 100
            "
          ></mat-progress-bar>
          <div class="progress-values">
            <h3 class="used-value">
              {{ +depositLimits[depositTime].deposited | currencyArs }}
            </h3>
            <h3 class="limit-value">{{ +depositLimits[depositTime].limit | currencyArs }}</h3>
          </div>
        </div>
      </div>

      <!-- Si tiene monthly su limite es mensual -->

      <div class="operation">
        <div class="operation-header">
          <img src="/assets/icons/operation.svg" alt="Limite de operacion" />
          <p class="title">Límites de operación</p>
          <app-selector
            [values]="optionsTime"
            (changeSelected)="operationTime = $event"
          ></app-selector>
        </div>

        <p class="amount">
          {{ +operationLimits[operationTime].limit | number : '0.2-2' }} <span>AR$</span>
        </p>

        <div class="progress">
          <div class="progress-values">
            <h3 class="used">Utilizados:</h3>
            <h3 class="limit">Límite:</h3>
          </div>
          <mat-progress-bar
            color="fff"
            mode="determinate"
            [value]="
              (+operationLimits[operationTime].operated / +operationLimits[operationTime].limit) *
              100
            "
          ></mat-progress-bar>
          <div class="progress-values">
            <h3 class="used-value">
              {{ +operationLimits[operationTime].operated | currencyArs }}
            </h3>
            <h3 class="limit-value">
              {{ +operationLimits[operationTime].limit | currencyArs }}
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
  <h2 class="documentation-title" *ngIf="!isCommerce">
    Orígenes de fondos <span>(NO arbitraje)</span>
  </h2>
  <p class="documentation-subtitle" *ngIf="!isCommerce">
    Para aumentar tu límite de operación, tenés que subir orígenes de fondos.
  </p>
  <app-reminder-message
    message="No se acepta constancia de monotributo o autónomos.
  La resolución sobre la documentación presentada la recibís en tu email, dentro de las 24 hs hábiles siguientes."
    type="warning"
    *ngIf="!isCommerce"
  >
  </app-reminder-message>
  <div class="options" *ngIf="!isCommerce">
    <div class="aclaration">
      <div>
        <div class="aclaration-title">
          <img src="/assets/icons/cross.svg" alt="cruz" />
          <p>Documentos <span>NO</span> aceptados:</p>
        </div>
        <ul class="list">
          <li class="element">
            <p>Documento nacional de identidad</p>
          </li>
          <li class="element">
            <p>Resumen bancario</p>
          </li>
          <li class="element">
            <p>Constancia de CUIT</p>
          </li>
          <li class="element">
            <p>Pago de impuesto</p>
          </li>
        </ul>
      </div>
      <img class="notDni" src="/assets/icons/not-dni.svg" alt="not dni" />
    </div>
  </div>
  <div class="options" *ngIf="!isCommerce">
    <div class="aclaration">
      <div>
        <div class="aclaration-title">
          <img src="/assets/icons/check.svg" alt="Check" />
          <p>Documentos aceptados:</p>
        </div>
        <ul class="list">
          <li class="element">
            <p>
              Recibo de sueldo de los últimos 3 meses. Se deben subir los 3 en un único PDF, en caso
              de subirse uno solo será rechazado
            </p>
            <p>
              Podés utilizar el servicio
              <span>
                <a
                  href="https://www.ilovepdf.com/merge_pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  >https://www.ilovepdf.com/merge_pdf</a
                ></span
              >
              para unirlas.
            </p>
          </li>
          <li class="element">
            <p>
              Si sos monotributista, presentar los últimos 3 VEPs de pago, de los últimos 3 meses.
              También se debe subir la constancia de CUIT. Los pagos del monotributo deben estar al
              día. La categoria mínima para analizar debe ser la F.
            </p>
          </li>
          <li class="element">
            <p>
              Si sos responsable inscripto (facturas A) debes presentar las últimas 3 posiciones de
              IVA pagas, de los ultimos 3 meses
            </p>
          </li>
          <li class="element">
            <p>
              Declaración Jurada (Ganancias o Bienes Personales) junto con la documentación del
              empleo.
            </p>
          </li>
          <li class="element">
            <p>
              Venta de títulos o propiedades, préstamos otorgados o certificado de origen de fondos
              (Certificado por contador público).
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="interactive">
    <div class="fund-origin" (click)="openFundOriginModal()" *ngIf="!isCommerce">
      <img src="assets/icons/upload-file.svg" alt="upload" />
      <span>Presentar documentación</span>
    </div>
  </div>
</div>
